import { ILandingPageComponentListingEventsPreviewQuery } from '../interfaces/landing-page-component-listing-events-preview.query.interface';
import { LandingPageComponentListingEventPreview } from './landing-page-component-listing-event-preview.model';

export class LandingPageComponentListingEventsPreview {
    items: LandingPageComponentListingEventPreview[];
    totalCount: number;

    constructor(query: ILandingPageComponentListingEventsPreviewQuery | null | undefined) {
        if (!query) {
            this.items = [];
            this.totalCount = 0;
            return;
        }

        this.items = (query.items || []).map((item) => new LandingPageComponentListingEventPreview(item));
        this.totalCount = query.total_count ?? this.items.length;
    }
}
